import { defineWebModule } from '@nexus/core-web';
import { de } from '../i18n/de';
import { en } from '../i18n/en';
import { manifest } from '../manifest';

/** Listed in apps/web/src/modules.ts. Pages load on first visit, each module is its own bundle. */
export const webModule = defineWebModule({
  manifest,
  messages: { de, en },
  documents: {
    'sigeko.inspection-report': () => import('./documents/inspection-report'),
  },
  pages: [
    {
      path: '/sigeko/inspections',
      load: () => import('./inspections-page'),
      permission: 'sigeko.inspection.read',
    },
    {
      path: '/sigeko/inspections/$id',
      load: () => import('./inspection-page'),
      permission: 'sigeko.inspection.read',
    },
  ],
  recordSections: [
    {
      key: 'sigeko.project-inspections',
      load: () =>
        import('./inspections-section').then((m) => ({ default: m.ProjectInspectionsSection })),
    },
    {
      key: 'sigeko.object-inspections',
      load: () =>
        import('./inspections-section').then((m) => ({ default: m.ObjectInspectionsSection })),
    },
  ],
  guides: [
    {
      id: 'sigeko.inspections',
      title: 'sigeko.guides.inspections.title',
      summary: 'sigeko.guides.inspections.summary',
      pages: ['/sigeko/inspections', '/sigeko/inspections/$id'],
      content: {
        de: () => import('./guides/inspections.de.md?raw'),
        en: () => import('./guides/inspections.en.md?raw'),
      },
    },
  ],
});
